import { render } from "./CashierAccount.vue?vue&type=template&id=a25aeb8a"
import script from "./CashierAccount.vue?vue&type=script&lang=js"
export * from "./CashierAccount.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__